export const fmtUSD = (value, options = {}) => {
  const { maximumFractionDigits = 2, minimumFractionDigits = 2 } = options;
  return `$${Number(value || 0).toLocaleString(undefined, {
    maximumFractionDigits,
    minimumFractionDigits,
  })}`;
};

export const fmtFP = (value) =>
  `${Math.round(Number(value || 0)).toLocaleString()} FP`;

export const fmtGameCredits = (value) => fmtUSD(value);
